import React, { ReactElement, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';
import {
  toggleLiveMatchList,
  toggleLiveMatchRequest,
} from '../../liveMatchSlice';
import boardCollabMatchBackground from '../../../../assets/png/board_collab_match.png';
import boardVsMatchBackground from '../../../../assets/png/board_vs_match.png';
import './LiveMatchListModal.scss';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import buttonRequestMatch from '../../../../assets/svg/btn_req.svg';
import buttonVsShuffle from '../../../../assets/svg/btn_vs_shuffle.svg';
import buttonCollabShuffle from '../../../../assets/svg/btn_collab_shuffle.svg';
import emptyImage from '../../../../assets/png/liver_mihaishin.png';
import { useGetListLiveMatchMutation } from '../../../../services/api/apiProvider';
import { RequestListLiveMatch } from '../../../../services/api/models/request/requestLiveMatch';
import {
  LiveMatchKindType,
  LiveMatchListMethod,
  LiveMatchType,
} from '../../types/LiveMatchTypes';
import { optionGlobal } from '../../../../common/constants/globalConstants';
import ViewAnotherLiveMatchModal from '../ViewAnotherLiveMatchModal/ViewAnotherLiveMatchModal';
import { ResponseLiveMatch } from '../../../../services/api/models/response/responseLiveMatch';
import { IResponseLive } from '../../../../services/api/models/response/responseLive';
export interface LiveBlockForMatchProps {
  live: IResponseLive;
  target: IResponseLive;
}

const LiveMatchListModal = (): ReactElement => {
  const dispatch = useDispatch();
  const [isShoModalViewAnotherLive, setIsShowModalViewAnotherLive] =
    useState<boolean>(false);
  const [liveMatchData, setLiveMatchData] = useState<LiveBlockForMatchProps>();
  const isShowListMatch = useSelector(
    (state: AppState) => state.liveMatch.isShowListMatch,
  );
  const liveData = useSelector((state: AppState) => state.live);
  const [getListLiveMatch, result] = useGetListLiveMatchMutation();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const request: RequestListLiveMatch = {
      method: LiveMatchListMethod.PLAYING,
      type: LiveMatchType.ANY,
      numOfPage: optionGlobal.numOfPage,
      numInPage: optionGlobal.numInPage,
    };
    await getListLiveMatch(request).unwrap();
  };

  const handleCloseModal = () => {
    dispatch(toggleLiveMatchList(false));
  };

  const handleOpenLiveMatchRequestModal = () => {
    dispatch(toggleLiveMatchRequest(true));
    dispatch(toggleLiveMatchList(false));
  };

  const handleCloseModalViewAnotherLive = (child: boolean) => {
    setIsShowModalViewAnotherLive(child);
  };

  const handleChoiceAnotherLive = (item: ResponseLiveMatch) => {
    if (liveData.role === 'host') {
      return;
    }
    const newLiveData: IResponseLive = {
      liveId: item.live.id,
      name: item.live.name,
      score: item.live.score,
      kind: item.live.kind,
      liverLeague: item.live.liverLeague,
      isRookies: item.live.isRookies,
      liveCategoryId: item.live.liveCategory?.id,
      liveCategoryName: item.live.liveCategory?.name,
      liveCategoryColor: item.live.liveCategory?.color,
      userId: item.live.user.id,
      userLoginId: item.live.user.loginId,
      userPictureUri: item.live.user.picture.uri,
    };
    const newTargetData: IResponseLive = {
      liveId: item.target.id,
      name: item.target.name,
      score: item.target.score,
      kind: item.target.kind,
      liverLeague: item.target.liverLeague,
      isRookies: item.target.isRookies,
      liveCategoryId: item.target.liveCategory?.id,
      liveCategoryName: item.target.liveCategory?.name,
      liveCategoryColor: item.target.liveCategory?.color,
      userId: item.target.user.id,
      userLoginId: item.target.user.loginId,
      userPictureUri: item.target.user.picture.uri,
    };

    setLiveMatchData({ live: newLiveData, target: newTargetData });
    setIsShowModalViewAnotherLive(true);
  };

  const renderList = () => {
    if (result.isLoading) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }
    if (!result.data || result.data.liveMatches.length <= 0) {
      return (
        <div className="block-group__empty">
          <img src={emptyImage} alt="empty-image" />
        </div>
      );
    }
    if (result.data && result.data.liveMatches.length > 0) {
      return (
        <>
          {result.data.liveMatches.map((item) => (
            <div
              onClick={() => {
                handleChoiceAnotherLive(item);
              }}
              key={item.id}
              className="match-list-image"
              style={{
                cursor: liveData.role === 'audience' ? 'pointer' : 'unset',
              }}
            >
              <img
                src={
                  item.kind === LiveMatchKindType.COLABO
                    ? boardCollabMatchBackground
                    : boardVsMatchBackground
                }
                alt=""
              />
              {item.kind === LiveMatchKindType.COLABO ? (
                <div className="match-item-title">
                  コラボ配信宜しくお願いします！
                </div>
              ) : (
                <div className="match-item-title">
                  VS配信宜しくお願いします！
                </div>
              )}

              <div className="match-item-left-user">
                <ImageCustom src={item.live.user.picture.uri} />
                <div className="match-item-user_name">
                  {item.live.user.loginId}
                </div>
              </div>
              <div className="match-item-right-user">
                <ImageCustom src={item.target.user.picture.uri} />
                <div className="match-item-user_name">
                  {item.target.user.loginId}
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>
      <Modal
        show={isShowListMatch}
        //   backdrop="static"
        keyboard={false}
        scrollable={true}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>マッチ</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="root-match-list">
            <div>マッチ配信一覧</div>
            {renderList()}
          </div>
        </Modal.Body>
        {liveData.role === 'host' && (
          <Modal.Footer>
            <div className="match-list-root-btn">
              <div
                onClick={handleOpenLiveMatchRequestModal}
                style={{ width: '60%' }}
                className="match-list-btn"
              >
                <img src={buttonRequestMatch} alt="buttonRequestMatch" />
              </div>
              <div className="match-list-btn">
                <img src={buttonVsShuffle} alt="buttonVsShuffle" />
              </div>
              <div className="match-list-btn">
                <img src={buttonCollabShuffle} alt="buttonCollabShuffle" />
              </div>
            </div>
          </Modal.Footer>
        )}
      </Modal>
      {liveData.role === 'audience' && (
        <ViewAnotherLiveMatchModal
          isShow={isShoModalViewAnotherLive}
          liveMatches={liveMatchData}
          closeModal={handleCloseModalViewAnotherLive}
        />
      )}
    </>
  );
};

export default LiveMatchListModal;
